import { Alert } from "@mui/material";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "../../redux/store";

export default function PasswordResetBanner() {
  const { passwordResetRequired } = useSelector(
    (state: RootState) => state.Auth.user
  );

  if (!passwordResetRequired) return null;

  return (
    <Alert
      severity="warning"
      sx={{
        position: "fixed",
        top: 70,
        width: "50%",
        zIndex: 1000,
        color: "#6e151e",
      }}
    >
      You are required to change your password. Please go to{" "}
      <Link to="/app/settings" style={{ fontWeight: "bold", color: "#6e151e" }}>
        settings
      </Link>
    </Alert>
  );
}
